export const environment = {
  production: false,
  documentUrl: 'https://dokument-test.lana.sparbankensyd.se/doc',
  authServiceUrl: 'https://dokument-test.lana.sparbankensyd.se/service',
  domain: 'dokument-test.lana.sparbankensyd.se'
}
